import styled from 'styled-components';

export const GradientDivider = styled.div`
  margin: 20px 0;
  width: 80px;
  height: 5px;
  border-radius: 5px;
  background: rgb(199,56,249);
  background: linear-gradient(90deg, rgba(199,56,249,1) 0%, rgba(30,207,245,1) 100%);
`;